var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-button",class:{button:_vm.isChecked}},[_c('img',{attrs:{"src":require("@/assets/img/cart/tick.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }